import errorMessages from "utils/validation/errorMessages";
import { dateRequiredSchema, endDateSchema, numberRequiredSchema, select2RequiredSchema, stringOptionalSchema, stringRequiredSchema } from "utils/validation/validationHelpers";
import { array, mixed, number, object, string } from 'yup';

const addStaffSchema = object().shape({
    task_title: stringRequiredSchema,
    task_datetime: stringRequiredSchema,
    // time: stringRequiredSchema,
    duration: select2RequiredSchema,
    custom_duration: object()
        .when('duration', {
            is: (val) => val?.value == 'custom',
            then: () => object().shape({
                every: numberRequiredSchema,
                durationType: select2RequiredSchema,
                frequency: mixed(),
            }),
            otherwise: () => object().optional(),
        }),
    ends_on: object()
        .when('duration', {
            is: (val) => val?.value == 'custom',
            then: () => select2RequiredSchema,
            otherwise: () => object().optional(),
        }),
    ends_on_data: string()
        .when('ends_on', {
            is: (val) => val?.value == 'on_date',
            then: () => object().shape({
                endDate: stringRequiredSchema,
            }),
            otherwise: () => object()
                .when('ends_on', {
                    is: (val) => val?.value == 'after',
                    then: () => object().shape({
                        occurence: numberRequiredSchema,
                    }),
                    otherwise: () => object().optional(),
                }),
        }),
    description: stringRequiredSchema,
    tracker_type: select2RequiredSchema,
    clientType: select2RequiredSchema,
    staff_id: select2RequiredSchema
});

export default addStaffSchema;